import * as Type from './types'

import { executeCallback, setInMemory } from '@services/store/utils'

const MODE = {
    [Type.POPULATE_AZURE]: 'azure',
    [Type.POPULATE_AWS]: 'aws'
}

const TYPE = {
    [Type.POPULATE_CONNECTED]: 'connected',
    [Type.POPULATE_DISCONNECTED]: 'disconnected'
}

const FORMAT_MODE = {
    [Type.SET_FORMAT_LIST]: 'list',
    [Type.SET_FORMAT_MODE]: 'mode'
}

const initialState = {
    data: {
        azure: {
            connected: [],
            disconnected: []
        },
        aws: {
            connected: []
        }
    },
    formated: {
        list: [],
        mode: -1
    },
    loaded: {
        azure: {
            connected: false,
            disconnected: false
        },
        aws: {
            connected: true
        }
    }
}

export default function LandingZonesReducer(state = initialState, action) {
    if (action.type === Type.POPULATE_AZURE || action.type === Type.POPULATE_AWS) {
        return executeCallback(
            setInMemory(state, action, 'data', MODE[action.type], TYPE[action.mode]),
            action,
            'landingZones'
        )
    }
    else if (action.type === Type.SET_FORMAT) {
        return executeCallback(
            setInMemory(state, action, 'formated', FORMAT_MODE[action.mode]),
            action,
            'landingZones'
        )
    }
    else if (action.type === Type.SET_LOADED) {
        return executeCallback(
            setInMemory(state, action, 'loaded', action.provider, action.mode),
            action,
            'landingZones'
        )
    }

    return state
}
